import { gql } from "@apollo/client";

export default gql`
  fragment AssessmentNomineeResponder on UserNode {
    id
    name
    avatar
    activeAssessmentNominationCount
  }

  fragment AssessmentNominee on AssessmentNominationNode {
    id
    # Null for a person removed from the organization. The three fields below are always set.
    responder {
      ...AssessmentNomineeResponder
    }
    responderId
    responderName
    responderDeactivated
  }

  query getAssessmentProgramNominees($programId: Int!, $targetId: Int!) {
    complianceProgram(pk: $programId) {
      id
      nominationsForUser(userId: $targetId) {
        edges {
          node {
            id
            ...AssessmentNominee
          }
        }
      }
    }
  }
`;
